import styled from '@emotion/styled';
import { DeleteOutline } from '@mui/icons-material';
import CollectionsIcon from '@mui/icons-material/Collections';
import DeviceHubIcon from '@mui/icons-material/DeviceHub';
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import useDeleteBranch from 'api/productDetail/useDeleteBranch/useDeleteBranch';
import DeleteModal from 'components/shared/DeleteModal/DeleteModal';
import BranchProductGallery from 'components/shared/Modals/productsList/Gallery/BranchProductGallery/BranchProductGallery';
import { usePageManager } from 'hooks/pageManager/usePageManager';
import { permissions } from 'hooks/permissions/permissions';
import { usePermissions } from 'hooks/permissions/usePermissions';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const BranchDetailsInfo = ({ branchDetails }) => {
  const [isBranchGalleryOpen, setIsBranchGalleryOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const navigate = useNavigate();
  const { refreshTabById } = usePageManager();
  const { can } = usePermissions();

  const branchListPermissions =
    permissions.general.categories.globalSettings.productManagement.branchList;
  const productDetailPermissions =
    permissions.general.categories.globalSettings.productManagement.productList
      .detail;

  const canDelete = can(branchListPermissions.delete);
  const canGoToRoot = can(productDetailPermissions.view);
  const canViewGallery = can(productDetailPermissions.branch.gallery);

  const [deleteBranch, deleteLoading] = useDeleteBranch();

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };

  const deleteHandle = () => {
    deleteBranch({ branchGuid: branchDetails?.guid }, () => {
      closeDeleteModal();
      refreshTabById(7);
      navigate('/branchesList');
    });
  };

  const goToRootPage = () => {
    navigate(`/productDetail/${branchDetails?.originGuid}`);
  };

  return (
    <Box>
      <TableContainer>
        <Typography
          sx={{ mb: 2, paddingX: '16px' }}
          variant="h5"
          fontSize={18}
          fontWeight={600}
        >
          جزئیات برنچ
        </Typography>
        <Table sx={{ minWidth: 900 }}>
          <TableHead>
            <TableRow
              sx={{
                '& .MuiTableCell-root': {
                  borderColor: 'rgba(100, 100, 100, .2)',
                  background: 'rgba(180, 180, 180, 0.05)',
                },
              }}
            >
              <TableCell
                align="right"
                sx={{ width: { xs: 'auto', lg: '450px', xl: '550px' } }}
              >
                نام
              </TableCell>

              <TableCell align="right">کدینگ</TableCell>
              <TableCell
                align="right"
                // sx={{ width: { xs: 'auto', lg: '450px', xl: '550px' } }}
              >
                ریشه
              </TableCell>

              <TableCell align="left" width={100}>
                عملیات ها
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            <TableRow>
              <TableCell align="left">{branchDetails?.display}</TableCell>
              <TableCell align="right">{branchDetails?.codding}</TableCell>
              <TableCell align="right">
                {branchDetails?.originDisplay}
              </TableCell>
              <TableCell align="left" width={260}>
                <ActionContainer>
                  <Box
                    sx={{
                      // flex: 1,
                      display: 'flex !important',
                      flexDirection: 'row',
                      justifyContent: 'end',
                      alignItems: 'center',
                      gap: 1,
                    }}
                  >
                    {canGoToRoot ? (
                      <Button
                        variant="contained"
                        size="small"
                        onClick={goToRootPage}
                        startIcon={
                          <DeviceHubIcon
                            style={{ margin: '0 -.5rem 0 .5rem' }}
                          />
                        }
                      >
                        ریشه
                      </Button>
                    ) : null}
                    {canViewGallery ? (
                      <Button
                        variant="contained"
                        size="small"
                        color="warning"
                        onClick={() => {
                          setIsBranchGalleryOpen(true);
                        }}
                        startIcon={
                          <CollectionsIcon
                            style={{ margin: '0 -.5rem 0 .5rem' }}
                          />
                        }
                      >
                        گالری
                      </Button>
                    ) : null}
                    {canDelete ? (
                      <Button
                        variant="contained"
                        size="small"
                        color="error"
                        startIcon={
                          <DeleteOutline
                            fontSize="small"
                            style={{ margin: '0 -.5rem 0 .5rem' }}
                          />
                        }
                        onClick={() => {
                          setIsDeleteModalOpen(true);
                        }}
                      >
                        حذف
                      </Button>
                    ) : null}
                  </Box>
                </ActionContainer>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      {canViewGallery && isBranchGalleryOpen ? (
        <BranchProductGallery
          open={isBranchGalleryOpen}
          onClose={() => setIsBranchGalleryOpen(false)}
          selected={branchDetails?.guid}
        />
      ) : null}

      {canDelete ? (
        <DeleteModal
          open={isDeleteModalOpen}
          title={branchDetails.display}
          locationId={branchDetails.guid}
          deleteLoading={deleteLoading}
          handleClose={closeDeleteModal}
          onDelete={deleteHandle}
        />
      ) : null}
    </Box>
  );
};

export default BranchDetailsInfo;

const ActionContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
`;
